// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1969":"css/admin-app.6642","9747":"css/app.6642"}[chunkId] + ".css";
};